/**
 * @fileoverview Active Clients filter-options query hook.
 * @description Wraps GET /sales/clients/filter-options in a TanStack query. The choices do not change
 * with the grid's archived switch, so one read serves the whole screen.
 * @copyright Copyright (c) 2026 Brownbox Consulting. All rights reserved.
 * @author Anshul Rokde
 */

import { useQuery } from '@tanstack/react-query'

import { SALES_CRM_QUERY_KEYS } from '@/features/sales/constants/prospects-query-keys.constants'
import { getClientFilterOptions } from '@/features/sales/services/sales-clients.service'

/**
 * @description Fetches the states and owners the grid can be filtered by.
 * @returns {ReturnType<typeof useQuery>} The query (data is the filter options).
 */
export function useClientFilterOptions() {
  return useQuery({
    queryKey: SALES_CRM_QUERY_KEYS.clientFilterOptions,
    queryFn: getClientFilterOptions,
  })
}
